/* global google */

(function() {
  "use strict";

  angular
    .module("app")
    .controller("TypeaheadController", [
      "$scope",
      "$attrs",
      "$filter",
      "NgMap",
      "$timeout",
      TypeaheadController
    ]);

  function TypeaheadController($scope, $attrs, $filter, NgMap, $timeout) {
    $scope.typeahead = {};

    $scope.resetTypeahead = function() {
      // Prevents first item from being selected automatically
      $scope.typeahead.selectedIndex = -1;

      $scope.typeahead.filteredResults = [];

      // Empty out typeahead input field
      $scope.queryString = "";
    };

    $scope.resetTypeahead();

    $scope.updateTypeahead = function(needle) {
      $scope.typeahead.filteredResults = $scope.state.communityData.filter(
        function(community) {
          return firstLettersFilter(community.name, needle);
        }
      );
    };

    $scope.focus = function(event) {
      $timeout(function() {
        $scope.updateTypeahead("");
      }, 150);
    };

    // Typeahead filter
    // Requirements: find matches for community names where any word starts with a user-provided
    // string. Example: `b` matches `Battery Park` and `Midtown Business District`
    // TODO - This should probably be its own filter file
    function firstLettersFilter(haystack, needle) {
      // Split the community name by any non-word characters
      var parsedStr = haystack.toLowerCase().split(/\W+/);

      // User input and strings to search are converted to lowercase
      needle = needle.toLowerCase();

      for (var i = 0; i < parsedStr.length; i++) {
        if (parsedStr[i].indexOf(needle) === 0) {
          // string match found!
          return true;
        }
      }

      // no string match found
      return false;
    }

    $scope.typeaheadKeyPressed = function(event, communityId) {
      // console.log(communityId);
      // console.log($scope.typeaheadSelected.index);
      if (event.key === "ArrowDown") {
        $scope.typeahead.selectedIndex += 1;
      }
      else if (event.key === "ArrowUp") {
        $scope.typeahead.selectedIndex =
          $scope.typeahead.selectedIndex >= -1
            ? $scope.typeahead.selectedIndex - 1
            : -1;
      }
      else if (event.key === "Enter") {
        var selectedId =
          $scope.typeahead.filteredResults[$scope.typeahead.selectedIndex].id;
        $scope.typeaheadSelected(selectedId);
      }
      else {
        // If the keypress isn't an arrow, it's probably a letter or number
        // Reset the selected index
        $scope.typeahead.selectedIndex = -1;
      }
    };

    function getBoundsZoomLevel(bounds, mapDim) {
      var WORLD_DIM = { height: 256, width: 256 };
      var ZOOM_MAX = 21;

      function latRad(lat) {
        var sin = Math.sin((lat * Math.PI) / 180);
        var radX2 = Math.log((1 + sin) / (1 - sin)) / 2;
        return Math.max(Math.min(radX2, Math.PI), -Math.PI) / 2;
      }

      function zoom(mapPx, worldPx, fraction) {
        return Math.floor(Math.log(mapPx / worldPx / fraction) / Math.LN2);
      }

      var ne = bounds.getNorthEast();
      var sw = bounds.getSouthWest();

      var latFraction = (latRad(ne.lat()) - latRad(sw.lat())) / Math.PI;

      var lngDiff = ne.lng() - sw.lng();
      var lngFraction = (lngDiff < 0 ? lngDiff + 360 : lngDiff) / 360;

      var latZoom = zoom(mapDim.height, WORLD_DIM.height, latFraction);
      var lngZoom = zoom(mapDim.width, WORLD_DIM.width, lngFraction);

      return Math.min(latZoom, lngZoom, ZOOM_MAX);
    }

    function getBounds(shape) {
      function extendBounds(bounds, point) {
        return bounds.extend(point);
      }

      return _.flatten(
        shape.getPaths().b.map(function(path) {
          return path.b;
        })
      ).reduce(extendBounds, new google.maps.LatLngBounds());
    }

    $scope.typeaheadSelected = function(id) {
      // Tracks when a user searches for a community from the "Communities by Risk" right rail on the "Risk Ranking" page and clicks on it
      var community = $scope.state.communitiesById[id];
      dataLayer.push({
        event: "Community Search",
        eventCategory: "Interactive Clicks",
        eventAction: "Community Search|" + community.name,
        eventLabel: window.location.pathname
      });

      $scope.state.selectedCommunities.toggleCommunity(id);
      $scope.resetTypeahead();

      if ($attrs.zoomOnSelection) {
        var bounds = getBounds($scope.cShapes[community.fips]);
        var center = bounds.getCenter(),
          mapDiv = $scope.map.getDiv(),
          zoom = getBoundsZoomLevel(bounds, {
            width: $(mapDiv).width(),
            height: $(mapDiv).height()
          });

        setTimeout(function() {
          $scope.map.setZoom(zoom);
          $scope.map.setCenter(center);
        }, 0);
      }
    };
  }
})();
